module.exports = function() {
  return new Worker(__webpack_public_path__ + "6a622fa25229313424bf.worker.js");
};